import { ChevronUp, ChevronsUp, Minus } from 'lucide-react';

import {
  CLASSES_PRIORIDADE,
  DESCRICOES_PRIORIDADE,
  ROTULOS_PRIORIDADE,
  type Prioridade,
} from '@/features/solicitacoes/status';
import { cn } from '@/lib/utils';

const ICONES = {
  ELETIVA: Minus,
  PRIORITARIA: ChevronUp,
  URGENTE: ChevronsUp,
} as const;

/**
 * Etiqueta de prioridade. Como o badge de status, combina texto, ícone e cor —
 * quem não distingue as cores lê o rótulo e vê a seta.
 */
export function BadgePrioridade({
  prioridade,
  className,
}: {
  prioridade: Prioridade;
  className?: string;
}) {
  const Icone = ICONES[prioridade];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        CLASSES_PRIORIDADE[prioridade],
        className,
      )}
      title={DESCRICOES_PRIORIDADE[prioridade]}
    >
      <Icone className="size-3" aria-hidden="true" strokeWidth={2.5} />
      {ROTULOS_PRIORIDADE[prioridade]}
    </span>
  );
}
